import { useCallback, useEffect, useRef } from 'react';

const useEventCallback = (fn: Function) => {
  const ref = useRef(fn);

  useEffect(() => {
    ref.current = fn;
  });

  return useCallback((...args) => ref.current.apply(void 0, args), []);
};

export default useEventCallback;
